import { Menu, MenuHandler, Button, MenuList, MenuItem, Typography } from '@material-tailwind/react';
import IonIcon from '@reacticons/ionicons';
import React from 'react'

import AIcon from '../../partials/AIcon';
import { useShared } from '../../../hooks/useShared'


export default function LanguagesMenu() {
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);
    const { pushSideBar,getLanguage, setLanguage } = useShared();

    const LANGUAGES = [
        { label: null, code: "", icon: '' },
        { label: "Dari", code: "dr", icon: 'flag-outline', labelO: "دری" },
        { label: "English", code: "en", icon: 'flag-outline', labelO: 'انگليسي' }
    ];
  
    const handleLangChange = (e) => {
        setLanguage(e);
        setIsMenuOpen(pre => !pre)
       
    }

    return (
        <Menu open={isMenuOpen} handler={setIsMenuOpen} placement="bottom-end"
            animate={{
                mount: { y: 0 },
                unmount: { y: 25 },
            }}
        >
            <MenuHandler>
                <div className='relative inline-block w-full'>
                    <Button variant="text" className='text-white-500  mr-3 flex items-center gap-1 p-2 justify-between w-full' >
                        <div className='flex '>
                            <AIcon size={18} name="language-outline" className={`text-green-300 ${getLanguage() === 'dr'?'ml-3':'mr-3'}`} />
                         {!pushSideBar &&   <span className=' text-gray-300 text-xs capitalize'>{getLanguage() === 'dr'? 'زبـــان':"Language"}</span>}
                        </div>

                        <IonIcon name="chevron-down-outline"
                            className={` text-white h-8 w-8 transition-transform ${isMenuOpen ? "rotate-180" : ""
                                }`}
                        />
                    </Button>

                </div>
            </MenuHandler>

            <MenuList className="flex flex-col min-w-[100px] p-1 ">

                {LANGUAGES.map(({ label, code, icon, labelO }, key) => {
                    const isLastItem = key === LANGUAGES.length - 1;
                    return (
                        <React.Fragment key={label}>
                            {isLastItem && <hr className="my-1 border-blue-gray-50" />}
                            <MenuItem
                                key={key}

                                onClick={() => handleLangChange(code)}
                                className={`${label === null ? 'h-0' : ''} flex items-center gap-2 p-1 rounded hover:bg-main-color hover:text-white active:bg-transparent focus:bg-transparent ${getLanguage() === code ? ' bg-main-color text-white' : ''}`}
                            >
                                <AIcon size={20} name={icon} className={`text-cyan-500 }`} />

                                <Typography
                                    as="span"
                                    variant="small"
                                    className="font-normal"

                                >
                                    <span className={getLanguage() === 'dr' ? 'amiriB' : ''}>{getLanguage() === 'en' ? label : labelO}</span>
                                </Typography>

                            </MenuItem>
                        </React.Fragment>
                    );
                })}
            </MenuList>
        </Menu>
    )
}
